import { render, staticRenderFns } from "./NoteEditDialog.vue?vue&type=template&id=581e166e&"
import script from "./NoteEditDialog.vue?vue&type=script&lang=js&"
export * from "./NoteEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports